/* eslint-disable no-dupe-keys */
export default {
  road_book: {
    name: '路书',
    // Enum的属性
    road_book_item: {
      entrance: '目的地线路图',
      charging_pile_guidance: '充电桩指引',
      charging_pile_position: '充电桩位置',
      surrounding_facilities: '周边设施',
      toilet: '洗手间',
      convenience_store: '便利店',
      simple_meals: '简餐',
      lounge: '休息室'
    },
    upload_images: '上传图片',
    tags: {
      destination: '目的地',
      charging_pile: '充电桩',
      ev_charging_pile: '充电桩',
      location: '位置'
    },
    edit: {
      notice: '提示',
      delete: '清空路书信息',
      detele_notice: '确定删除路书嘛？删除将不可恢复'
    }
  }
}
